import { Component } from '@angular/core';
import { MapService } from './map.service';
import { DataLayerService } from './data-layer.service';
import { ConfigService } from './config.service';

// This class supports legends associated with additional layers.
// Because the selector is <img>, any image appropriate for that tag can be used: gif, png, etc.
// After the legend component has been created, the following routines must be called:
// 		setData - including the id and legendUrl
// 		subscribe - creates the communication link between the map component and this legend 
// Note also that the activateLayer function in the class must activate the legend as well:
		// activate legend as well
		// const legendDisplay = this.mapService.getDataLayerLegendDisplay(this.id);
		// if ( legendDisplay != null ) {
		// 	legendDisplay['source'].next (true);
		// }
		// deactivateLayer must also deactivate the legend
		// const legendDisplay = this.mapService.getDataLayerLegendDisplay(this.id);
		// if ( legendDisplay != null ) {
		// 	legendDisplay['source'].next (false);
		// }

@Component({
	selector: 'data-layer-legend',
  	standalone: false,
	template: `
		<img class="additionalLegendUrl" src="{{legendUrl}}" [ngClass]="{ 'hideAdditionalLegend': hideAdditionalLegend}" > 
		`,
	styleUrls: ['map.component.css']
})
export class AdditionalLegendsComponent  {
	configService: ConfigService;
	mapService: MapService;
	id: string;
	legendUrl: string;
	hideAdditionalLegend = true;

	constructor(configService: ConfigService, mapService: MapService ) {
		this.configService = configService;
		this.mapService = mapService;
	}

	// this routine must exist because it does get called but since the legend is not changing, no action is required.
	refreshLayer() {}

	// setData must be called in order to assign an identifier to this legend and assign the source of the legend image
	setData ( someData: any ) {
		/*
		// the id of this legend is the same as the id of the entire layer - 
		// that is how they are associated with each other so it's important that ids are unique in the configuration file.
		if ( someData.hasOwnProperty('id')) {
			this.id = someData.id;
			console.log('Adding legend for id ' + this.id);
		}

		// legendUrl is directory passed to the src component of the image
		if ( someData.hasOwnProperty('legendUrl')) {
			if ( someData.legendUrl.startsWith('http')) {
				this.legendUrl = someData.legendUrl;
			} else {
				this.legendUrl = this.configService.baseDir + someData.legendUrl;
			}
		}
		*/
	}

	// Once the legend has been created, a communications link to the map component must be created.  mapService becomes this
	// communication link.
	subscribe () {
		/*
		this.mapService.createNewDataLayerLegendDisplay(this.id);
		const legendDisplay = this.mapService.getDataLayerLegendDisplay(this.id);
		console.log(legendDisplay);

		// subscribe to the mapService legendDisplay for the appropriate layer.
		// display is only a boolean alerting to either hide the legend or not
		legendDisplay['observable'].subscribe( display => {
			 console.log("Toggling legend");
			this.hideAdditionalLegend = !display;
			legendDisplay['display'] = !this.hideAdditionalLegend;  // ?
			this.mapService.calculateDataLayerLegendCount();
		});
		*/
	}

}